import React, {useState} from 'react';
import Dropdown from '../../component/DropDown/DropDown';
import SearchInput from '../../component/SearchInput/SearchInput';
import {Times, ViewPen} from '../../assets/icons';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import styles from '../../styles/CallTypeSetup.module.scss';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';

const CallTypeSetup = () => {
  const [clearModal, setClearModal] = useState(false);
  const tableData = [
    {
      id: 4,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Active',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    {
      id: 3,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Inactive',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    {
      id: 9,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Active',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
    {
      id: 6,
      name: 'Fidelity Green Rewards',
      code: 'Lsl-THE OTH 521627',
      groupName: 'Active',
      itemName: 'candy',

      brandName: 'The Store',
      price: '139150 Points',
    },
  ];
  return (
    <div>
      {' '}
      <CallCenterStructure>
        <div className={styles.CallCenterQueryType}>
          <div className={styles.headerText}>
            <p>Call Type Setup</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.field1}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Call Type<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Resolution Type ID<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Query type ID<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Subquery type ID<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Communication Type<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Query details<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Next action date<sup>*</sup>
                </label>
                <input type="date" name="" id="" />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Closure date<sup>*</sup>
                </label>
                <input type="date" name="" id="" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Resolution Priority level<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Query assigned<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Query status<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Query log ticket<sup>*</sup>
                </label>
                <Dropdown />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button className={styles.submit}>Submit</button>
              <button
                className={styles.reset}
                type="button"
                onClick={() => setClearModal(true)}>
                Reset
              </button>
            </div>
          </div>
          <div className={styles.tableSection}>
            {/* <div className={styles.searchInputContainer}>
              <div className={styles.searchInput}>
                <SearchInput />
              </div>
              <button className={styles.searchBTN}>Search</button>
            </div> */}
            <div className={styles.innerTableContainer}>
              <table className={styles.mainTable}>
                <thead>
                  <tr>
                    <th>Call Type</th>
                    <th>Resolution Type</th>
                    <th>Query Type</th>
                    <th>Subquery Type</th>
                    <th>Communication Type</th>

                    <th>Priority Level</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map(each => (
                    <tr key={each.id}>
                      <td>{each.name}</td>
                      <td>{each.code}</td>
                      <td>{each.itemName}</td>
                      <td>{each.groupName}</td>
                      <td>{each.itemName}</td>
                      <td>{each.groupName}</td>

                      <td>
                        <div className={styles.iconContainer}>
                          <span className={styles.icon}>
                            <Times />
                          </span>
                          <span className={styles.icon}>
                            <ViewPen />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Pass your clear input function to clearInputFn */}
        <ClearInputModal
          //   clearInputFn={handleReset}
          clearModalStatus={clearModal}
          clearInputModalState={setClearModal}
        />
      </CallCenterStructure>
    </div>
  );
};

export default CallTypeSetup;
